import { v4 as uuidv4 } from 'uuid';

const getItems = (key, initialData = []) => {
    try {
        const items = localStorage.getItem(key);
        if (items) {
            return JSON.parse(items);
        } else {
            // Initialize with initial data if local storage is empty
            localStorage.setItem(key, JSON.stringify(initialData));
            return initialData;
        }
    } catch (error) {
        console.error(`Error getting items from localStorage for key "${key}":`, error);
        return initialData; // Return initial data on error
    }
};

const getItemById = (key, id) => {
    const items = getItems(key);
    return items.find(item => item.id === id);
};

const addItem = (key, item) => {
    const items = getItems(key);
    const newItem = { ...item, id: uuidv4(), createdAt: new Date().toISOString() };
    const updatedItems = [...items, newItem];
    localStorage.setItem(key, JSON.stringify(updatedItems));
    return newItem;
};

const updateItem = (key, id, updatedItem) => {
    const items = getItems(key);
    const updatedItems = items.map(item =>
        item.id === id ? { ...item, ...updatedItem, updatedAt: new Date().toISOString() } : item
    );
    localStorage.setItem(key, JSON.stringify(updatedItems));
    return { ...updatedItem, id }; // Return the updated item structure
};

const deleteItem = (key, id) => {
    const items = getItems(key);
    const updatedItems = items.filter(item => item.id !== id);
    localStorage.setItem(key, JSON.stringify(updatedItems));
};

export const storageService = {
    getItems,
    getItemById,
    addItem,
    updateItem,
    deleteItem,
};